import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class AttributesListDto
*  
*/
export class AttributesListDto extends ActiveModel {

  /**
  * allByIds
  * Словарь с информацией о всех атрибутах, где: <para /><br>- ключ: идентификатор атрибута; <para /><br>- значение: данные атрибута<br>  */
  @ActiveField(() => undefined)
  allByIds?: Record<string, object>


  /**
  * wellKnown
  * Словарь с информацией об известных предопределённых атрибутах, где: <br><br>- ключ: системный идентификатор атрибута; <para /><br>- значение: идентификатор атрибута<br>  */
  @ActiveField(() => undefined)
  wellKnown?: Record<string, number>
}
